import { useReducer } from 'react';

const initialState = {
    visible: false,
    start: { x: 200, y: 200 },
    end: { x: 400, y: 200 },
    isDragging: false,
    isRotating: false,
    dragOffset: { x: 0, y: 0 },
    rotatingEndpoint: null
};

const rulerReducer = (state, action) => {
    switch (action.type) {
        case 'SET_VISIBLE':
            return { ...state, visible: action.payload };
        case 'SET_START':
            return { ...state, start: action.payload };
        case 'SET_END':
            return { ...state, end: action.payload };
        case 'START_DRAGGING':
            return { ...state, isDragging: true, dragOffset: action.payload };
        case 'STOP_DRAGGING':
            return { ...state, isDragging: false, dragOffset: { x: 0, y: 0 } };
        case 'START_ROTATING':
            return { ...state, isRotating: true, rotatingEndpoint: action.payload };
        case 'STOP_ROTATING':
            return { ...state, isRotating: false, rotatingEndpoint: null };
        case 'UPDATE_POSITION':
            return { 
                ...state, 
                start: action.payload.start, 
                end: action.payload.end 
            };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
};

export const useRuler = (initialVisible = false) => {
    const [state, dispatch] = useReducer(rulerReducer, {
        ...initialState,
        visible: initialVisible
    });

    const actions = {
        setVisible: (visible) => dispatch({ type: 'SET_VISIBLE', payload: visible }),
        setStart: (start) => dispatch({ type: 'SET_START', payload: start }),
        setEnd: (end) => dispatch({ type: 'SET_END', payload: end }),
        startDragging: (offset) => dispatch({ type: 'START_DRAGGING', payload: offset }),
        stopDragging: () => dispatch({ type: 'STOP_DRAGGING' }),
        startRotating: (endpoint) => dispatch({ type: 'START_ROTATING', payload: endpoint }),
        stopRotating: () => dispatch({ type: 'STOP_ROTATING' }),
        updatePosition: (start, end) => dispatch({ type: 'UPDATE_POSITION', payload: { start, end } }),
        reset: () => dispatch({ type: 'RESET' })
    };

    return [state, actions];
};
